<template>
    <div class="w-full relative flex md:flex-row flex-col z-40 font-fira text-white flex-wrap references justify-center">
        <div @click="$modal.show('ecomodal')"
             class="md:w-1/3 w-full refs overflow-hidden relative flex items-center justify-center ref__logo bg-v-blue-dark">
            <img class="w-full" src="../assets/refs/eco/ecotemp1-xs.jpg">
            <div class="absolute pin-b pin-l pb-8 pl-8 text-xl font-hairline flex flex-wrap"><h1 class="uppercase font-normal text-xl">Ecotemp <span class="font-hairline mr-1">|  </span></h1><span>  logó és arculat</span></div>

        </div>
        <div @click="$modal.show('noemodal')"
             class="md:w-1/3 refs overflow-hidden relative flex z-50 items-center justify-center ref__logo bg-v-blue-dark">
            <img class="w-full" src="../assets/refs/noe/noe1-max.jpg">
            <div class="absolute pin-b pin-l pb-8 pl-8 text-xl font-hairline flex flex-wrap"><h1 class="uppercase font-normal text-xl">Noe állatotthon <span class="font-hairline mr-1">|  </span></h1><span>  landing
                page koncepció</span></div>
        </div>
        <div @click="$modal.show('htmodal')"
             class="md:w-1/3 refs overflow-hidden relative z-50 flex items-center justify-center ref__logo bg-v-blue-dark">
            <img class="w-full" src="../assets/refs/ht/HT2-max.jpg">
            <div class="absolute pin-b pin-l pb-8 pl-8 text-xl font-hairline flex flex-wrap"><h1 class="uppercase font-normal text-xl">HTBurkolás <span class="font-hairline mr-1">|  </span></h1><span>  logó és
                weboldal design</span></div>
        </div>
    </div>
</template>

<script>
export default {
  data () {
    return {}
  }
}
</script>
<style lang="scss" scoped>
    div > img {
        opacity: 0.2;
        transition: opacity 1s;
        object-fit: cover;
        height: 100%;
    }

    div:hover > img {
        opacity: 1;
    }

    .ref__logo {
        transition: .2s ease-in-out;
        transition-property: transform, box-shadow, border;
        border-bottom: 1px solid white;
        @media (min-width: 768px) {
            border: none;
        }
    }

    .ref__logo:hover {
        transition: .2s ease-out;
        transform: scale(1.05, 1.05);
        overflow: hidden;
        border: none;
        box-shadow: 2px 2px 30px rgba(0, 0, 0, 0.5);
        color: transparent;
        z-index: 100;
    }

    .refs {
        height: 200px;
        @media (min-width: 768px) {
            height: 350px;
        }
    }

</style>



// WEBPACK FOOTER //
// src/components/References.vue